import React from 'react';
import CustomSplitColumnCard from '@common/components/misc/CustomSplitColumnCard';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { TagIcon } from '@common/utils/icons/icons';
import CustomAlert from '@common/components/Feedback/CustomAlert';
import TagsInfo from './TagsInfo';
import ErrorsInfo from './ErrorsInfo';
import { selectIsAdvancedModeEnabled } from '@common/store/app-configurations/app-configurations-selectors';
import { useSharedSelector } from '@common/store/SharedProvider';

const SupportInformation: React.FC = () => {
  const { t } = useTranslation();

  const isAdvancedModeEnabled = useSharedSelector((state) => selectIsAdvancedModeEnabled(state));

  return (
    <React.Fragment>
      <Stack spacing={2} width="100%" alignItems="center" p={0.3}>
        <CustomSplitColumnCard
          title={t('title-robot-support')}
          content={[
            {
              left: (
                <Stack spacing={1} pr={2}>
                  <Stack direction="row" alignItems="center" spacing={1} py={1}>
                    <TagIcon />
                    <Typography>{t('title-robot-tags')}</Typography>
                  </Stack>
                  <CustomAlert header={t('info-robot-tags')} severity="info" />
                </Stack>
              ),
              right: <TagsInfo />,
            },
          ]}
        />
        {isAdvancedModeEnabled && (
          <CustomSplitColumnCard
            title={t('validation-error-title')}
            content={[{ left: <ErrorsInfo /> }]}
          />
        )}
      </Stack>
    </React.Fragment>
  );
};

export default SupportInformation;
